document.addEventListener('DOMContentLoaded' , () =>{
    // product - product-lists-page
    if(document.querySelector('.product-lists-page')){
        $('.prd-visual__slide').slick({
			lazyLoad: 'ondemand',
            dots:true,
            arrows:false,
            autoplay:true,
        })
    }

    // product - js-btn-col
    if(document.querySelector('.js-btn-col')){
        let btnCol = document.querySelectorAll('.js-btn-col'),
            prdList = document.querySelectorAll('.prd-list');
        
        btnCol.forEach(function(el){
            let colToggleBtnArray = Array.from(el.parentNode.querySelectorAll('.js-btn-col'));

            el.addEventListener('click' , function(e){
                if(!el.classList.contains('on')){
                    colToggleBtnArray.forEach(function(el){
                        el.classList.remove('on');
                    });
                    el.classList.add('on');
                }

                //목록 스타일
                if(el.classList.contains('btn-col1')){
                    prdList.forEach(function(el){
                        el.className = 'prd-list prd-list--col1';
                    })
                }else{
                    prdList.forEach(function(el){
                        el.className = 'prd-list';
                    })
                }
            });
        })
    }

    // product - product-view-page
    if(document.querySelector('.product-view-page')){
        $('.prd-visual').slick({
            dots:true,
            arrows:false,
        });

        $('.prd-banner__list').slick({
            dots:true,
            arrows:false,
            autoplay:true,
            autoplaySpeed:5000
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			$(".prd-banner__control .current").html(nextSlide + 1);
		});
        
        const btnInfo = document.querySelector('.btn-info');
        btnInfo.addEventListener('click' , function(){
            btnInfo.classList.toggle('active');
        });

        const viewPage = document.querySelector('.product-view-page');
        // console.log(viewPage);
        // document.querySelector('.js_wish')

        const detailedInfo = viewPage.querySelector('.detailed-info__img_info');
        // console.log(detailedInfo);
        // console.log(viewPage.querySelector('.js_viewInfo'));
        viewPage.querySelector('.js_viewInfo').addEventListener('click', function(){
            detailedInfo.classList.add('active');
        });

        const buyProcess = viewPage.querySelector('.buy-process');
        if(document.querySelector('.js_showOption')){
            viewPage.querySelectorAll('.js_showOption').forEach(function(el){
                el.addEventListener('click', function(){
                    buyProcess.classList.add('active');
                    document.querySelector('html, body').style.overflow = 'hidden';
                    document.querySelector('.buy-process__bg').style.display = 'block';
                });
            })

            viewPage.querySelectorAll('.js_closeOption').forEach(function(el){
                el.addEventListener('click', function(){
                    buyProcess.classList.remove('active');
                    document.querySelector('html, body').style.overflow = 'visible';
                    document.querySelector('.buy-process__bg').style.display = 'none';
                    document.querySelector('.js_toggle_btn').classList.remove('active');
                    document.querySelector('.buy-process__option-box').classList.remove('ovf-visible');
                });
            })
        }
        
        //상품상세 js_tabBtn fixed
		const prdTabBtn = document.getElementById("js_tabBtn"),
              prdTabBtnOfs = window.scrollY + prdTabBtn.getBoundingClientRect().top;
        // const prdTabCon = window.scrollY + prdTabBtn.getBoundingClientRect().top;

		window.onscroll = function () {
		  let windowTop = window.scrollY;
		  if (windowTop >= prdTabBtnOfs) {
			prdTabBtn.classList.add("fixed");
		  } else {
			prdTabBtn.classList.remove("fixed");
		  }
		};

    }

    if(document.querySelector('.qna-list')){
        //상품상세 문의 탭, 마이페이지 1:1문의
        const qnaToggleBtn = document.querySelectorAll('.js-btn-qna');

        qnaToggleBtn.forEach(function(el){
            let qnaToggleBtnArray = Array.from(el.parentNode.parentNode.querySelectorAll('.js-btn-qna'));

            el.addEventListener('click' , function(e){
                if(el.parentNode.classList.contains('on')){
                    el.parentNode.classList.remove('on');
                }else{
                    qnaToggleBtnArray.forEach(function(el){
                        el.parentNode.classList.remove('on');
                    });
                    el.parentNode.classList.add('on');
                }
            });
        })
    }

    if(document.querySelector('.member-grade')){
        const memberGradeBtn = document.querySelector('.js_member_grade');
              memberGrade = document.querySelector('.member-grade');

        memberGradeBtn.addEventListener('click', function(){
            memberGradeBtn.classList.toggle('active');
            memberGrade.classList.toggle('active');
        });
    }

    // cumulative-review - 누적 리뷰수 숫자 카운팅 인터랙션
    if(document.querySelector('.cumulative-review')){
        function countNumber(){
            let $this = $('.count_number'),
                countTo = $this.attr('data-number');
    
            if($this.hasClass('end')){
                $this.removeClass('end');
                $this.text("0"); //숫자 초기화
            }
    
            $({countNum: $this.text()}).animate({
                countNum: countTo 
            },
            {
                duration: 2000,
                easing:'linear',
                step: function(){
                    $this.text(Math.floor(this.countNum));
                },
                complete: function(){
                    $this.text(this.countNum);
                    $this.addClass('end');
                }
            }); 
        }
    
        countNumber();
        setInterval(countNumber, 5000);
    }
});
